import { cn } from '@/utils/commonUtil'
import { formatPercentage } from '@/utils/formatUtil'

import styles from './StatCommonDonutPercentage.module.scss'

type Props = {
  percentage?: number
}

const RADIUS = 44
const CIRCUMFERENCE = 2 * RADIUS * Math.PI
const CURVE = CIRCUMFERENCE * 0.72

export const StatCommonDonutPercentage = ({ percentage = 0 }: Props) => {
  const value = formatPercentage(percentage)
  const [integer, fraction] = value.split('.')
  const is100 = value === '100'

  const colorScheme = percentage < 0.1 ? 'low' : percentage < 0.6 ? 'mid' : 'high'

  return (
    <span
      className={cn(styles.container, {
        colorScheme,
        hasDecimal: !!fraction,
        is100,
        isLessThanZero: Number(integer) <= 0,
        styles,
      })}
    >
      <svg className={styles.graphic} viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
        <circle
          className={styles.track}
          cx='50'
          cy='50'
          fill='none'
          r={RADIUS}
          strokeDasharray={`${CURVE} ${CIRCUMFERENCE}`}
          strokeLinecap='round'
          strokeWidth='12'
          transform='rotate(140 50 50)'
        />
        <circle
          className={styles.arc}
          cx='50'
          cy='50'
          fill='none'
          r={RADIUS}
          strokeDasharray={`${CURVE * percentage} ${CIRCUMFERENCE}`}
          strokeLinecap='round'
          strokeWidth='12'
          transform='rotate(140 50 50)'
        />
      </svg>
      <data className={styles.percentage} value={percentage}>
        <span className={styles.value}>
          {integer}
          {fraction && (
            <>
              <span className={styles.decimal}>.</span>
              <span>{fraction}</span>
            </>
          )}
        </span>
        <span className={styles.percentSign}>%</span>
      </data>
    </span>
  )
}
